import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';

export default function BlogPost() {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <>
        <div className="min-h-screen p-8">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold mb-8">Blog yazısı bulunamadı</h1>
            <Link to="/blog" className="text-blue-600 hover:underline">Blog sayfasına dön</Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Helmet>
        <title>{`${post.title} - Solar Tools Blog`}</title>
        <meta name="description" content={post.excerpt} />
        <link rel="canonical" href={`https://www.solartools.com.tr/blog/${post.slug}`} />
      </Helmet>
      <div className="min-h-screen p-8">
        <div className="max-w-4xl mx-auto">
          <article className="bg-white rounded-lg shadow-lg overflow-hidden">
            {post.imageUrl && (
              <img 
                src={post.imageUrl} 
                alt={post.title}
                className="w-full h-64 object-cover"
              />
            )}
            <div className="p-8">
              <h1 className="text-4xl font-bold mb-4">{post.title}</h1>
              <div className="flex items-center text-sm text-gray-500 mb-4">
                <span className="mr-4">{post.author}</span>
                <span>{post.date}</span>
              </div>
              <div className="flex flex-wrap gap-2 mb-8">
                {post.tags.map((tag, index) => (
                  <span 
                    key={index}
                    className="px-3 py-1 bg-blue-100 text-blue-600 rounded-full text-sm"
                  >
                    {tag}
                  </span>
                ))}
              </div>
              <div className="prose max-w-none">
                <p className="text-gray-700 leading-relaxed">{post.content}</p>
              </div>
              <Link 
                to="/blog"
                className="mt-8 inline-block bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition-colors"
              >
                Blog Sayfasına Dön
              </Link>
            </div>
          </article>
        </div>
      </div>
    </>
  );
} 